import React from 'react';
import { Carousel as RCarousel } from 'react-responsive-carousel';

import graduation from '../assets/graduation.png';
import cooperativism from '../assets/cooperativism.jpeg';
import couple from '../assets/couple.jpeg';
import aquisition from '../assets/aquisition.jpeg';

function Carousel() {
  return (
    (
      <RCarousel
        centerMode
        autoPlay
        interval={4000}
        centerSlidePercentage={100}
        dynamicHeight={false}
        infiniteLoop
        showArrows={false}
        showStatus={false}
        showIndicators={false}
        showThumbs={false}
      >
        <div>
          <img src={cooperativism} alt="Imagem cooperativismo" height="400px" />
        </div>
        <div>
          <img src={graduation} alt="Imagem graduação" height="400px"  />
        </div>
        <div>
          <img src={couple} alt="Imagem casal" height="400px"  />
        </div>
        <div>
          <img src={aquisition} alt="Imagem aquisição" height="400px"  />
        </div>
      </RCarousel>
    )
  )
}

export default Carousel;